import React from 'react'
import merge from 'lodash/merge'
import { PanelProps } from './Panel.types'

const Panel: React.FC<PanelProps> = ({
    noPadding,
    titleStyle = {},
    bodyStyle = {},
    footer,
    footerStyle,
    children,
    title,
    fullHeight,
    style,
    sub = false,
    isDiscreet = false,
    type = 'default',
    withTabs = false,
    className = '',
    buttons = null,
    onClick = () => {},
}) => {
    const _style = {
        height: fullHeight ? '100%' : 'auto',
    }

    const classNames = () => {
        const c = ['r-panel', className]

        if (type) {
            c.push('r-state-' + type)
        }

        if (sub) {
            c.push('r-panel-sub')
        }

        if (withTabs) {
            c.push('r-panel-with-tabs')
        }

        if (isDiscreet) {
            c.push('r-state-discreet')
        }

        return c.join(' ')
    }

    const _bodyStyle = {
        padding: noPadding ? 0 : null,
    }

    const _footerStyle = {
        padding: noPadding ? 0 : null,
    }

    return (
        <div onClick={onClick} data-testid='Panel' style={merge(style, _style)} className={classNames()}>
            {title ? (
                <div className='r-panel-heading' style={titleStyle}>
                    <div className='r-panel-title'>{title}</div>
                    {buttons ? <div className={'r-panel-buttons'}>{buttons}</div> : null}
                </div>
            ) : (
                ''
            )}
            <div className='r-panel-body' style={merge(_bodyStyle, bodyStyle)}>
                {children}
            </div>
            {footer ? (
                <div className='r-panel-footer' style={merge(_footerStyle, footerStyle)}>
                    {footer}
                </div>
            ) : (
                ''
            )}
        </div>
    )
}

export default Panel
